"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValueSelected = void 0;

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.array.index-of.js");

// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
var isValueSelected = function isValueSelected(value, candidate) {
  if (candidate === undefined || value === undefined) {
    return false;
  }

  if (Array.isArray(candidate) && typeof value === 'string') {
    return candidate.indexOf(value) >= 0;
  }

  return value === candidate;
};

exports.isValueSelected = isValueSelected;